import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, GitCompare } from 'lucide-react';
import { getFriendProfile } from '../api';

export default function FriendProfile() {
  const { friendId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFriendProfile(friendId)
      .then(res => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [friendId]);

  if (loading) return <div className="loading"><div className="spinner spinner--lg" /></div>;
  if (!data) return <div className="empty-state"><p>Could not load friend profile.</p></div>;

  const { friend, systems } = data;
  const displayName = friend.username || `${friend.firstName} ${friend.lastName}`;

  return (
    <div className="fade-in">
      <Link to="/friends" className="back-link"><ArrowLeft size={14} /> Friends</Link>

      <div className="page-header" style={{ marginBottom: '24px' }}>
        <div className="friend-profile__header">
          <div className="friend-profile__avatar">
            {displayName[0].toUpperCase()}
          </div>
          <div>
            <h1 className="page-header__title">{displayName.toUpperCase()}</h1>
            {friend.username && (
              <p className="page-header__subtitle">{friend.firstName} {friend.lastName}</p>
            )}
          </div>
        </div>
      </div>

      <h2 className="section-header__title" style={{ marginBottom: '12px' }}>
        TRAIL SYSTEMS
        <span className="text-muted" style={{ fontWeight: 400, fontSize: '13px', marginLeft: '8px' }}>
          {systems.length} system{systems.length !== 1 ? 's' : ''}
        </span>
      </h2>

      {systems.length === 0 ? (
        <div className="empty-state">
          <p>{friend.firstName} hasn't added any trail systems yet.</p>
        </div>
      ) : (
        <div className="grid grid--gap-lg">
          {systems.map(system => (
            <div key={system._id} className="card system-card">
              <div className="flex-1">
                <div className="system-card__name">{system.name}</div>
                <div className="system-card__meta">
                  {[system.region, system.country].filter(Boolean).join(', ')}
                </div>
                <div className="system-card__progress-row">
                  <div className="progress-bar" style={{ flex: 1 }}>
                    <div className="progress-bar__fill" style={{ width: `${system.pct}%` }} />
                  </div>
                  <span className="system-card__stats">
                    {system.completedTrails}/{system.totalTrails} trails · {system.pct}%
                  </span>
                </div>
                {system.shared && (
                  <Link
                    to={`/friends/${friendId}/compare/${system._id}`}
                    className="friend-profile__compare-link"
                  >
                    <GitCompare size={12} /> Compare progress
                  </Link>
                )}
              </div>
              {system.shared && <span className="pill pill--shared">Shared</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
